(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peruutusilmoitus"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const juuri = document.querySelector('.peruutus');
    if (!juuri) return;

    const form = document.getElementById('PeruutusForm');

    // --- Kaksivaiheinen lomake ---
    if (form && !form.querySelector('[data-peruutus-success]')) {
      const step1 = form.querySelector('[data-step="1"]');
      const step2 = form.querySelector('[data-step="2"]');
      const tuotteetKentta = form.querySelector('[data-tuotteet]');
      const yhteenveto = form.querySelector('[data-yhteenveto]');
      const bodyKentta = form.querySelector('input[name="contact[body]"]');

      const kentta = (nimi) => form.querySelector(`[name="contact[${nimi}]"]`);

      const naytaTuotteet = () => {
        const osa = form.querySelector('[name="contact[Laajuus]"]:checked')?.value === 'Osa tilauksesta';
        tuotteetKentta.hidden = !osa;
        // Pakollinen vain kun kenttä on näkyvissä, muuten selain estäisi lähetyksen piilotetun kentän takia
        kentta('Tuotteet').required = osa;
      };

      form.querySelectorAll('[name="contact[Laajuus]"]').forEach((r) => {
        r.addEventListener('change', naytaTuotteet);
      });
      naytaTuotteet();

      const kerraaTiedot = () => ({
        nimi: kentta('name').value.trim(),
        email: kentta('email').value.trim(),
        tilausnumero: kentta('Tilausnumero').value.trim(),
        tilauspaiva: kentta('Tilauspaiva').value.trim(),
        laajuus: form.querySelector('[name="contact[Laajuus]"]:checked')?.value || '',
        tuotteet: tuotteetKentta.hidden ? '' : kentta('Tuotteet').value.trim(),
      });

      form.querySelector('[data-jatka]').addEventListener('click', () => {
        if (!form.reportValidity()) return;

        const d = kerraaTiedot();

        const rivit = [
          ['Nimi', d.nimi],
          ['Sähköposti', d.email],
          ['Tilausnumero', d.tilausnumero],
          ['Tilauspäivä', d.tilauspaiva],
          ['Peruutus koskee', d.laajuus],
          ['Peruutettavat tuotteet', d.tuotteet],
        ].filter(([, arvo]) => arvo);

        yhteenveto.innerHTML = rivit
          .map(([otsikko, arvo]) => {
            const turvallinen = document.createElement('div');
            turvallinen.textContent = arvo;
            return `<dt>${otsikko}</dt><dd>${turvallinen.innerHTML}</dd>`;
          })
          .join('');

        bodyKentta.value =
          'PERUUTUSILMOITUS\n\n' +
          rivit.map(([otsikko, arvo]) => `${otsikko}: ${arvo}`).join('\n');

        // Talteen, jotta Klaviyo-tapahtuma voidaan lähettää sivun latauduttua uudelleen
        sessionStorage.setItem('peruutus', JSON.stringify(d));

        step1.hidden = true;
        step2.hidden = false;
        step2.focus();
        step2.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      form.querySelector('[data-takaisin]').addEventListener('click', () => {
        step2.hidden = true;
        step1.hidden = false;
        step1.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    // --- Klaviyo-tapahtuma onnistuneen lähetyksen jälkeen ---
    const onnistui = juuri.querySelector('[data-peruutus-success]');
    if (!onnistui) return;

    const tallennettu = sessionStorage.getItem('peruutus');
    if (!tallennettu) return;
    sessionStorage.removeItem('peruutus');

    const siteId = juuri.dataset.klaviyoSiteId;
    const revision = juuri.dataset.klaviyoRevision;
    if (!siteId) return;

    let d;
    try {
      d = JSON.parse(tallennettu);
    } catch (e) {
      return;
    }

    fetch(`https://a.klaviyo.com/client/events/?company_id=${encodeURIComponent(siteId)}`, {
      method: 'POST',
      headers: {
        'content-type': 'application/vnd.api+json',
        revision: revision,
      },
      body: JSON.stringify({
        data: {
          type: 'event',
          attributes: {
            metric: {
              data: { type: 'metric', attributes: { name: 'Peruutusilmoitus lahetetty' } },
            },
            profile: {
              data: { type: 'profile', attributes: { email: d.email, first_name: d.nimi } },
            },
            properties: {
              Aikaleima: onnistui.dataset.aikaleima,
              Tilausnumero: d.tilausnumero,
              Tilauspaiva: d.tilauspaiva,
              Laajuus: d.laajuus,
              Tuotteet: d.tuotteet,
            },
          },
        },
      }),
    }).catch(() => {});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peruutustoiminto"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('peruutus-lomake')) {
    customElements.define(
      'peruutus-lomake',
      class PeruutusLomake extends HTMLElement {
        connectedCallback() {
          if (this.alustettu) return;
          this.alustettu = true;

          this.tekstit = JSON.parse(this.querySelector('[data-tekstit]').textContent);
          this.lomake = this.querySelector('[data-lomake]');
          this.vaihe1 = this.querySelector('[data-vaihe="1"]');
          this.vaihe2 = this.querySelector('[data-vaihe="2"]');
          this.tuotteet = this.querySelector('[data-tuotteet]');
          this.yhteenveto = this.querySelector('[data-yhteenveto]');
          this.virhe = this.querySelector('[data-virhe]');
          this.vahvista = this.querySelector('[data-vahvista]');
          this.takaisin = this.querySelector('[data-takaisin]');
          this.onnistui = this.querySelector('[data-onnistui]');

          this.esitayta();

          this.lomake.querySelectorAll('[name="laajuus"]').forEach((r) =>
            r.addEventListener('change', () => this.paivitaLaajuus())
          );
          this.paivitaLaajuus();

          this.querySelector('[data-jatka]').addEventListener('click', () => this.siirryTarkistukseen());
          this.takaisin.addEventListener('click', () => this.palaaMuokkaamaan());
          this.lomake.addEventListener('submit', (e) => {
            e.preventDefault();
            this.laheta();
          });
        }

        kentta(nimi) {
          return this.lomake.elements.namedItem(nimi);
        }

        esitayta() {
          // Linkki tilausvahvistuksesta: ?tilaus=%231042
          const tilaus = new URLSearchParams(window.location.search).get('tilaus');
          const kentta = this.kentta('tilaus');
          if (tilaus && kentta && !kentta.value) kentta.value = tilaus.trim().slice(0, 100);
        }

        laajuus() {
          return this.lomake.querySelector('[name="laajuus"]:checked')?.value === 'osa' ? 'osa' : 'koko';
        }

        paivitaLaajuus() {
          const osa = this.laajuus() === 'osa';
          this.tuotteet.hidden = !osa;
          // Pakollinen vain näkyvissä, muuten piilotettu kenttä estäisi etenemisen.
          this.kentta('tuotteet').required = osa;
        }

        keraa() {
          const arvo = (nimi) => (this.kentta(nimi)?.value || '').trim();
          const lisakentat = [...this.lomake.querySelectorAll('[data-lisakentta]')]
            .map((el) => ({ nimi: el.dataset.lisakentta, arvo: el.value.trim() }))
            .filter((k) => k.arvo);
          return {
            nimi: arvo('nimi'),
            email: arvo('email'),
            tilaus: arvo('tilaus'),
            laajuus: this.laajuus(),
            tuotteet: this.laajuus() === 'osa' ? arvo('tuotteet') : '',
            lisakentat,
            verkkosivu: arvo('verkkosivu'),
          };
        }

        siirryTarkistukseen() {
          if (!this.lomake.reportValidity()) return;

          this.tiedot = this.keraa();
          this.pyynto = window.crypto?.randomUUID
            ? window.crypto.randomUUID()
            : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;

          const t = this.tekstit;
          const d = this.tiedot;
          const rivit = [
            [t.nimi, d.nimi],
            [t.email, d.email],
            [t.tilaus, d.tilaus],
            [t.laajuus, d.laajuus === 'osa' ? t.osa : t.koko],
          ];
          if (d.tuotteet) rivit.push([t.tuotteet, d.tuotteet]);
          d.lisakentat.forEach((k) => rivit.push([k.nimi, k.arvo]));

          this.yhteenveto.replaceChildren(
            ...rivit.flatMap(([otsikko, arvo]) => {
              const dt = document.createElement('dt');
              const dd = document.createElement('dd');
              dt.textContent = otsikko;
              dd.textContent = arvo;
              return [dt, dd];
            })
          );

          this.naytaVirhe('');
          this.vaihe1.hidden = true;
          this.vaihe2.hidden = false;
          this.vaihe2.focus();
          this.vaihe2.scrollIntoView({ behavior: 'smooth', block: 'start' });
          this.kaynnistaTarkistus();
        }

        palaaMuokkaamaan() {
          this.vaihe2.hidden = true;
          this.vaihe1.hidden = false;
          this.vaihe1.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

        async odotaTurnstile() {
          for (let i = 0; i < 50; i++) {
            if (window.turnstile) return window.turnstile;
            await new Promise((r) => setTimeout(r, 200));
          }
          return null;
        }

        async kaynnistaTarkistus() {
          this.token = null;
          this.vahvista.disabled = true;

          const sitekey = this.dataset.sitekey;
          const turnstile = sitekey ? await this.odotaTurnstile() : null;
          if (!turnstile) {
            console.warn('Peruutuslomake: Turnstile ei latautunut', sitekey ? 'skripti estetty tai hidas' : 'site key puuttuu');
            this.naytaVirhe(this.korvaaVaraosoite(this.tekstit.tarkistusVirhe || this.tekstit.virhe));
            return;
          }

          if (this.widgetId !== undefined) {
            turnstile.reset(this.widgetId);
            return;
          }

          this.widgetId = turnstile.render(this.querySelector('[data-turnstile]'), {
            sitekey,
            language: this.dataset.kieli || 'auto',
            callback: (token) => {
              this.token = token;
              this.vahvista.disabled = false;
            },
            'expired-callback': () => {
              this.token = null;
              this.vahvista.disabled = true;
            },
            'error-callback': (koodi) => {
              // Virhekoodi näkyy selaimen konsolissa: 110200 = osoite puuttuu widgetin hostnameista.
              console.warn('Peruutuslomake: Turnstile-virhe', koodi);
              this.token = null;
              this.vahvista.disabled = true;
              this.naytaVirhe(this.korvaaVaraosoite(this.tekstit.tarkistusVirhe || this.tekstit.virhe));
            },
          });
        }

        korvaaVaraosoite(teksti) {
          return (teksti || '').replace('{varaosoite}', this.tekstit.varaosoite || '');
        }

        virheteksti() {
          return this.korvaaVaraosoite(this.tekstit.virhe);
        }

        naytaVirhe(viesti) {
          this.virhe.textContent = viesti;
          this.virhe.hidden = !viesti;
        }

        async laheta() {
          if (!this.token || !this.tiedot) return;

          this.vahvista.disabled = true;
          this.takaisin.disabled = true;
          this.setAttribute('aria-busy', 'true');
          this.naytaVirhe('');

          try {
            const vastaus = await fetch(this.dataset.worker, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                ...this.tiedot,
                kieli: this.dataset.kieli,
                turnstile: this.token,
                pyynto: this.pyynto,
              }),
            });
            const tulos = await vastaus.json().catch(() => ({}));

            if (vastaus.ok && tulos.ok) {
              this.naytaOnnistuminen(tulos);
              return;
            }
            this.naytaVirhe(this.virheteksti());
          } catch (e) {
            this.naytaVirhe(this.virheteksti());
          } finally {
            this.removeAttribute('aria-busy');
            this.takaisin.disabled = false;
          }

          // Uusi tarkistus seuraavaa yritystä varten. Sama pyyntö-id estää tuplaviestit.
          this.token = null;
          if (window.turnstile && this.widgetId !== undefined) window.turnstile.reset(this.widgetId);
        }

        naytaOnnistuminen(tulos) {
          this.querySelector('[data-onnistui-teksti]').textContent = (this.tekstit.onnistui || '')
            .replace('{aika}', tulos.aikaleima || '')
            .replace('{email}', tulos.email || this.tiedot.email);
          this.lomake.hidden = true;
          this.onnistui.hidden = false;
          this.onnistui.focus();
          this.onnistui.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
